import { UserGeneralKey } from '@/models/user.generalkey';
export class AuthService {
    static startTokenExpirationCheck() {
        this.stopTokenExpirationCheck();
        this.checkTokenExpiration();
        this.checkInterval = setInterval(() => {
            this.checkTokenExpiration();
        }, this.CHECK_INTERVAL);
    }
    static stopTokenExpirationCheck() {
        if (this.checkInterval) {
            clearInterval(this.checkInterval);
            this.checkInterval = null;
        }
    }
    static checkTokenExpiration() {
        const token = localStorage.getItem(UserGeneralKey.USER_TOKEN);
        if (!token) {
            return;
        }
        if (!UserGeneralKey.isTokenValid()) {
            this.handleTokenExpiration();
        }
    }
    static handleTokenExpiration() {
        UserGeneralKey.logout();
        this.showExpirationMessage();
        setTimeout(() => {
            window.location.href = '/';
        }, 2000);
    }
    static showExpirationMessage() {
        const notification = document.createElement('div');
        notification.style.cssText = `
            position: fixed;
            top: 20px;
            right: 20px;
            background: #f44336;
            color: white;
            padding: 15px 20px;
            border-radius: 5px;
            z-index: 9999;
            font-family: Arial, sans-serif;
            box-shadow: 0 4px 6px rgba(0,0,0,0.1);
        `;
        notification.textContent = '🔐 Votre session a expiré. Redirection vers la page de connexion...';
        document.body.appendChild(notification);
        setTimeout(() => {
            if (notification.parentNode) {
                notification.parentNode.removeChild(notification);
            }
        }, 3000);
    }
    static isAuthenticated() {
        const token = localStorage.getItem(UserGeneralKey.USER_TOKEN);
        return token ? UserGeneralKey.isTokenValid() : false;
    }
    static getTokenExpirationTime() {
        const token = localStorage.getItem(UserGeneralKey.USER_TOKEN);
        if (!token)
            return null;
        try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            const expiry = payload.exp;
            const now = Math.floor(Date.now() / 1000);
            const timeLeft = expiry - now;
            return Math.max(0, Math.floor(timeLeft / 60));
        }
        catch (error) {
            return null;
        }
    }
}
AuthService.checkInterval = null;
AuthService.CHECK_INTERVAL = 60000;
